import { colorsMatrix, Heading, StyledFlex, Text } from '@dreryk/react-components';

import { patientPortalTranslationKeys } from '../../translations';

import { WidgetHelpCenterLink } from './WidgetHelpCenterButton';
import { WidgetInfoClipboard } from './WidgetInfoClipboard';

type WidgetInfoProps = {
   readonly scriptHtmlTag: string;
   readonly installationManualLink: string;
};

export const WidgetInfo = (props: WidgetInfoProps): JSX.Element => {
   const { scriptHtmlTag, installationManualLink } = props;
   return (
      <StyledFlex direction={'column'} gap={'8px'} flex={'0 1 28%'}>
         <Heading
            content={patientPortalTranslationKeys.widget.scriptInfo}
            testId={'widgetScriptInfoHeading'}
            type={'h3'}
            bold
         />
         <Text testId={'scriptHtmlTag'} whiteSpaces={'break-spaces'} color={colorsMatrix.grey.dark}>
            {scriptHtmlTag}
         </Text>
         <StyledFlex gap={'16px'} alignItems={'center'}>
            <WidgetInfoClipboard value={scriptHtmlTag} />
            <WidgetHelpCenterLink installationManualLink={installationManualLink} />
         </StyledFlex>
      </StyledFlex>
   );
};
